// Centralised data-testid registry
export const TESTIDS = {
  // Header
  header: 'site-header',
  navLogo: 'nav-logo',
  navServices: 'nav-services',
  navGallery: 'nav-gallery',
  navAreas: 'nav-areas',
  navReviews: 'nav-reviews',
  navContact: 'nav-contact',
  headerCallBtn: 'header-call-button',
  mobileMenuToggle: 'mobile-menu-toggle',

  // Hero
  heroSection: 'hero-section',
  heroCtaQuote: 'hero-cta-quote',
  heroCtaCall: 'hero-cta-call',

  // Services
  servicesSection: 'services-section',
  serviceCard: 'service-card',

  // Trust
  trustSection: 'trust-section',

  // Gallery
  gallerySection: 'gallery-section',
  galleryImage: 'gallery-image',

  // Areas
  areasSection: 'areas-section',

  // Reviews
  reviewsSection: 'reviews-section',
  reviewCard: 'review-card',

  // Contact form
  contactSection: 'contact-section',
  contactForm: 'contact-form',
  contactName: 'contact-name-input',
  contactPhone: 'contact-phone-input',
  contactEmail: 'contact-email-input',
  contactPostcode: 'contact-postcode-input',
  contactService: 'contact-service-select',
  contactMessage: 'contact-message-input',
  contactSubmit: 'contact-submit-button',
  contactSuccess: 'contact-success-message',
  contactError: 'contact-error-message',

  // Footer
  footerSection: 'site-footer',
  footerEmail: 'footer-email-link',
  footerPhone: 'footer-phone-link',
};

// Legacy export retained for any template usage
export const HOME = { emergentLink: 'home-emergent-link' };
